import _defineProperty from "/builds/vtblife/frontend/common/gatsby-party/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _slicedToArray from "/builds/vtblife/frontend/common/gatsby-party/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import React, { useCallback, useState, useRef, useEffect } from 'react';
import classNames from 'classnames';
import s from './collapse.module.css';
import useSlots from '../../hooks/use-slots';
import { openedContext, useAccordion } from './utils';
import { Title } from './slots';
import { containsNode } from '../../utils/dom';
var Item = function Item(_ref) {
  var children = _ref.children,
    title = _ref.title,
    _ref$opened = _ref.opened,
    externalOpened = _ref$opened === void 0 ? false : _ref$opened,
    _ref$onToggle = _ref.onToggle,
    onToggle = _ref$onToggle === void 0 ? function () {} : _ref$onToggle,
    itemProp = _ref.itemProp,
    itemScope = _ref.itemScope,
    itemType = _ref.itemType,
    variant = _ref.variant;
  var _useState = useState(externalOpened),
    _useState2 = _slicedToArray(_useState, 2),
    selected = _useState2[0],
    setSelected = _useState2[1];
  var control = useRef(null);
  var content = useRef(null);
  var slots = useSlots('Collapse', children);
  useEffect(function () {
    return setSelected(externalOpened);
  }, [externalOpened]);
  var _useAccordion = useAccordion(control),
    toggle = _useAccordion.toggle;
  var handleToggleEvent = useCallback(function (_ref2) {
    var detail = _ref2.detail;
    if (!control.current || content.current && containsNode(content.current, detail.target)) {
      return;
    }
    var currentState = control.current.open;
    toggle();
    setSelected(!currentState);
    if (!detail.artificial) {
      onToggle(!currentState, detail.event);
    }
  }, [toggle, onToggle]);
  useEffect(function () {
    if (!control.current) {
      return;
    }
    var el = control.current;
    el.addEventListener('uikit:collapse-toggle', handleToggleEvent);
    return function () {
      el.removeEventListener('uikit:collapse-toggle', handleToggleEvent);
    };
  });
  var handleClick = useCallback(function (event) {
    if (!content.current || !containsNode(content.current, event.target)) {
      event.preventDefault();
    }
  }, []);
  return React.createElement("details", Object.assign({
    className: classNames(s.item, variant && _defineProperty({}, s[variant], selected)),
    open: externalOpened,
    ref: control,
    onClick: handleClick
  }, {
    itemProp: itemProp,
    itemScope: itemScope,
    itemType: itemType
  }), React.createElement(openedContext.Provider, {
    value: selected
  }, React.createElement("summary", null, title ? React.createElement(Title, null, title) : slots.title), React.createElement("div", {
    ref: content,
    "data-content": true,
    className: s.content
  }, slots.children)));
};
export default Item;